import React from "react";
import { useSelector } from "react-redux";
import Spinner from "../../../components/presentationals/Spinner";
import Error from "../../../components/Error/index";
import RechargeSalesOthersCustomizedTables from "../../../components/table/rechageSalesOthersCustomizedTable";

const OthersBottom5RetailersView = ({ partnerRT }) => {
  const { getBottomFiveRetailer } = useSelector(
    (state) => state.rechargeSalesReducer
  );

  let bottom5RetailersData = getBottomFiveRetailer.data;

  const emptyObject = {
    0: { id: "", name: "", rechargeAmount: "" },
  };

  return (
    <>
      {partnerRT === "DT" ? (
        <>
          <RechargeSalesOthersCustomizedTables data={emptyObject} />
        </>
      ) : (
        <>
          {getBottomFiveRetailer.loading ? (
            <Spinner />
          ) : Object.keys(bottom5RetailersData).length ? (
            <RechargeSalesOthersCustomizedTables data={bottom5RetailersData} />
          ) : (
            <Error error={getBottomFiveRetailer.error} />
          )}
        </>
      )}
    </>
  );
};

export default OthersBottom5RetailersView;
